import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { withClassname } from '@components/hoc/withClassname';
import * as storage from '@inqool/uas-web-core/es/utils/storage';

import { DelictsForm } from '@modules/delicts/DelictsForm';

import ActionBar from '@modules/delicts/DelictsGridButtons';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const delictsUrl = '/metropolis/api/ed/delicts';
export const delictsLabel = 'Přestupky';
export const delictsPath = '/delicts';
export const delictsGridName = 'DelictsGrid';

export const DelictsGrid = compose(
  withRouter,
  setDisplayName(delictsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: delictsLabel }]),
  withColumns(Agenda.DELICTS),
  withProps(({ columns }) => ({
    name: delictsGridName,
    url: delictsUrl,
    Form: DelictsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      allowRestore: (() => {
        try {
          const permissions: Array<string> = JSON.parse(storage.get('permissions'));
          const ok = permissions.find(p => p === 'ROLE_DELETED_VIEW');
          return () => ok;
        } catch (e) {
          return () => false;
        }
      })(),
      sort: 'created',
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 13,
      ActionBar
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsGrid.tsx